/**
 * Persistable allows users to keep their settings saved on local storage.
 *
 * It will create a confluence.%%_LOGGED_USER_NAME_%%.userSettings.%%_FIELD_NAME_%% with the value of the
 * checked attribute or the value attribute.
 *
 * JSON.stringify/parse is used to handle boolean and potentially non-scalar types.
 *
 * Created as a port of confluence/persistable module.
 */

import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager';

// scope is a unique identifier, can be a pageId or any other string
// that you consider as scope for persisting something
function getStorageKey(key, scope) {
	return scope ? `${key}.${scope.replace(/\./g, '-')}` : key;
}

function get(name, scope, defaultValue) {
	let value = typeof defaultValue !== 'undefined' ? defaultValue : null;

	try {
		const storageKey = getStorageKey(name, scope);
		const persistedValue = localStorage.getItem(storageKey);
		if (persistedValue !== null && persistedValue !== 'undefined') {
			// un-stringify the value
			value = JSON.parse(persistedValue);
		}
	} catch (e) {}

	return value;
}

function set(name, scope, defaultValue, value) {
	const storageKey = getStorageKey(name, scope);

	if (value === defaultValue) {
		localStorage.removeItem(storageKey);
	} else {
		const expireTime = 30 * 24 * 60 * 60; // 30 days - we don't use * 1000 here because storageManager already does it internally
		localStorage.setItem(storageKey, JSON.stringify(value), expireTime);
	}
}

export default {
	get,
	set,
};
